<section class="hero-wrapper">
  <div class="hero">
    <header class="hero__header">
      <h1 class="hero__header__title"><span class="line-break">À chacun</span> sa solution.</h1>
      <ul class="hero__header__actions">
        <li>
          <button
            class="btn hero__header__actions__btn"
            type="button"
            aria-label="Se rendre à la section Jeunes"
            (click)="goToYoungSection()"
          >
            Je suis jeune
          </button>
        </li>
        <li>
          <a
            class="btn-clean btn hero__header__actions__btn"
            [routerLink]="['/', FeaturesRoutingEnum.EmployerSpace]"
            (click)="trackEvent({ category: 'Home', action: 'Click Employeurs', type: 'navigation' })"
          >
            Je suis employeur
          </a>
        </li>
      </ul>
    </header>
    <ul
      [@imagesAnimation]="illustrations.length"
      class="hero__illustrations"
      *ngIf="illustrations$ | async as illustrations"
    >
      <li *ngFor="let illustration of illustrations; trackBy: trackByIllustration; let i = index">
        <img
          class="hero__illustrations__img"
          [src]="illustration | imaginarySrc: 1:222"
          [srcset]="illustration | imaginarySrc: 4:222"
          alt=""
        />
      </li>
    </ul>
  </div>
</section>
